module.exports = __webpack_public_path__ + "static/media/image-web-4.4f753c0c.png";